/*
 * @Author: zhenhui.duan
 * @Date: 2024-05-15 11:33:41
 */
import { useCallback, useContext, useEffect, useState } from 'react';
import CurrencyInfoContext from '@pages/currencyInfo/context';
import { Message } from '@ok/okd';
import utils from '@common/utils';
import URL from '../../common/URL';
import BaseInfo from '../BaseInfo';
import PriceList from '../PriceList';
import PriceInfo from '../PriceInfo';
import Resource from '../Resource';
import Faq from '../Faq';

const { utils: { ont } = {} } = window;

export default () => {
  const { currency, currencyInfo, loading } = useContext(CurrencyInfoContext);
  const [currencyPublicInfo, setCurrencyPublicInfo] = useState({});

  const fetchCurrencyPublicInfo = useCallback(async () => {
    try {
      const data = await ont.get(
        `${URL.GET_CURRENCY_PUBLIC_INFO}?currencyId=${currency.id}`
      );
      setCurrencyPublicInfo(data?.data?.data || {});
    } catch (err) {
      Message.error(err?.msg || '');
    }
  }, [currency?.id]);

  useEffect(() => {
    if (utils.isNotEmpty(currency.id)) {
      fetchCurrencyPublicInfo();
    }
  }, [currency?.id, fetchCurrencyPublicInfo]);

  return (
    <>
      <BaseInfo
        loading={loading}
        currencyInfo={currencyInfo}
        currencyPublicInfo={currencyPublicInfo}
      />
      <PriceList currency={currency} />
      <PriceInfo
        currencyInfo={currencyInfo}
        currencyPublicInfo={currencyPublicInfo}
      />
      <Resource />
      <Faq />
    </>
  );
};
